import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["number"]
  static values = { target: Number, duration: { type: Number, default: 1500 } }

  connect() {
    if (!("IntersectionObserver" in window)) {
      this.numberTarget.textContent = String(this.targetValue)
      return
    }
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animate()
          this.observer.disconnect()
        }
      })
    }, { threshold: 0.35 })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  animate() {
    const start = performance.now()
    const from = 0
    const to = this.targetValue
    const duration = this.durationValue
    const ease = (t) => 1 - Math.pow(1 - t, 3)
    const step = (now) => {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)
      const value = Math.round(from + (to - from) * ease(progress))
      this.numberTarget.textContent = value.toLocaleString()
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}
